/** 实验报告生成（F-023）：参数快照 + 指标汇总表 + 对比结论占位，输出 Markdown。 */
import type { ExperimentResult } from './export-csv';
import { strategyLabel } from '../strategy/registry';
import { sceneLabel } from './templates';

function row(r: ExperimentResult): string {
  if (!r.ok) return `| ${sceneLabel(r.sceneId)} | ${strategyLabel(r.strategyId)} | ${r.seed} | 失败：${r.error ?? ''} | — | — | — | — |`;
  const s = r.summary;
  return `| ${sceneLabel(r.sceneId)} | ${strategyLabel(r.strategyId)} | ${r.seed} | ${s.deliveredCount} | ${(s.avgWaitMs / 1000).toFixed(1)} | ${s.throughputPerHour.toFixed(0)} | ${(s.carUtilization * 100).toFixed(0)}% | ${s.energyKwh.toFixed(2)} |`;
}

export function generateReport(results: readonly ExperimentResult[]): string {
  const ok = results.filter((r) => r.ok);
  const first = results[0];
  const header = first ? `> 场景：${sceneLabel(first.sceneId)}　种子：${first.seed}　实验数：${results.length}` : '';

  const minWait = ok.length ? ok.reduce((a, b) => (a.summary.avgWaitMs <= b.summary.avgWaitMs ? a : b)) : null;
  const maxThru = ok.length ? ok.reduce((a, b) => (a.summary.throughputPerHour >= b.summary.throughputPerHour ? a : b)) : null;

  return [
    '# 电梯调度实验报告',
    '',
    header,
    '',
    '## 指标汇总',
    '',
    '| 场景 | 策略 | 种子 | 送达 | 平均等待(s) | 吞吐(/h) | 利用率 | 能耗(kWh) |',
    '|---|---|---:|---:|---:|---:|---:|---:|',
    ...results.map(row),
    '',
    '## 对比结论（占位，请按需补充）',
    '',
    minWait ? `- 平均等待最低：**${strategyLabel(minWait.strategyId)}**（${(minWait.summary.avgWaitMs / 1000).toFixed(1)}s）` : '- （无有效结果）',
    maxThru ? `- 吞吐最高：**${strategyLabel(maxThru.strategyId)}**（${maxThru.summary.throughputPerHour.toFixed(0)}/h）` : '',
    '- （请补充你的分析与结论）',
    '',
    '## 参数与种子快照',
    '',
    '详见各实验导出的 JSON（config / seed / 策略参数）。',
    '',
  ].join('\n');
}
